<template>

  <vx-card :title="$t('live-class-schedule.schedule-detail')">

    <div class="vx-row mb-3">

      <div class="vx-col sm:w-1/2 w-full">
        <ValidationProvider :name="$t('live-class-schedule.topic-local')" rules="required"
                            v-slot="{ errors }">
          <label class="text-sm">{{$t('live-class-schedule.topic-local') + ' *'}}</label>
          <vs-input class="w-full" v-model="form.advisorOnlineScheduleInput.topicLocal"/>
          <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
        </ValidationProvider>
      </div>

      <div class="vx-col sm:w-1/2 w-full">
        <label class="text-sm">{{$t('live-class-schedule.topic-eng')}}</label>
        <vs-input class="w-full" v-model="form.advisorOnlineScheduleInput.topicEng"/>
      </div>

    </div>

    <div class="vx-row mb-3">
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <label class="text-sm">{{$t('class-section.description-local')}}</label>
        <vs-textarea rows="3" v-model="form.advisorOnlineScheduleInput.descriptionLocal"/>
      </div>
      <div class="vx-col sm:w-1/2 w-full mb-2">
        <label class="text-sm">{{$t('class-section.description-eng')}}</label>
        <vs-textarea rows="3" v-model="form.advisorOnlineScheduleInput.descriptionEng"/>
      </div>
    </div>


    <div class="vx-row mb-3">

      <div class="vx-col sm:w-1/3 w-full">
        <ValidationProvider :name="$t('live-class-schedule.on-air-date')" rules="required" v-slot="{ errors }">
          <label class="text-sm">{{$t('live-class-schedule.on-air-date') + ' *'}}</label>
          <datepicker :disabledDates="disabledStartDates" :format="dateTimeFormat.yyyymmdd"
                      @input="onDateFromChange"
                      v-model="form.advisorOnlineScheduleInput.dateTimeFrom"></datepicker>
          <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
        </ValidationProvider>
      </div>

      <div class="vx-col sm:w-1/3 w-full">
        <div class="vx-row">

          <div class="vx-col sm:w-1/2">
            <ValidationProvider :name="$t('live-class-schedule.date-time-from')" rules="required" v-slot="{ errors }">
              <label class="text-sm">{{$t('live-class-schedule.date-time-from') + ' *'}}</label>
              <v-select :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        :name="$t('live-class-schedule.date-time-from')" :options="advisorOnlineScheduleEdit.hour"
                        @input="onTimeChange"
                        class="w-full mb-1"
                        selectOnTab
                        v-model="advisorOnlineScheduleEdit.selectedHourFrom">
              </v-select>
              <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
            </ValidationProvider>

          </div>
          <div class="vx-col sm:w-1/2">
            <ValidationProvider :name="$t('live-class-schedule.minute-from')" rules="required" v-slot="{ errors }">
              <br>
              <v-select :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        :name="$t('live-class-schedule.minute-from')" :options="advisorOnlineScheduleEdit.minute"
                        @input="onTimeChange"
                        class="w-full mb-1"
                        selectOnTab
                        v-model="advisorOnlineScheduleEdit.selectedMinuteFrom">
              </v-select>
              <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
            </ValidationProvider>
          </div>

        </div>
      </div>

      <div class="vx-col sm:w-1/3 w-full">

        <div class="vx-row">

          <div class="vx-col sm:w-1/2">
            <ValidationProvider :name="$t('live-class-schedule.date-time-to')" rules="required" v-slot="{ errors }">
              <label class="text-sm">{{$t('live-class-schedule.date-time-to') + ' *'}}</label>
              <v-select :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        :name="$t('live-class-schedule.date-time-to')" :options="advisorOnlineScheduleEdit.hour"
                        @input="onTimeChange"
                        class="w-full mb-1"
                        selectOnTab
                        v-model="advisorOnlineScheduleEdit.selectedHourTo">
              </v-select>
              <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
            </ValidationProvider>

          </div>
          <div class="vx-col sm:w-1/2">
            <ValidationProvider :name="$t('live-class-schedule.minute-to')" rules="required" v-slot="{ errors }">
              <br>
              <v-select :clearable="false" :dir="$vs.rtl ? 'rtl' : 'ltr'"
                        :name="$t('live-class-schedule.minute-to')" :options="advisorOnlineScheduleEdit.minute"
                        @input="onTimeChange"
                        class="w-full mb-1"
                        selectOnTab
                        v-model="advisorOnlineScheduleEdit.selectedMinuteTo">
              </v-select>
              <span class="text-danger text-sm" v-show="errors[0]">{{errors[0]}}</span>
            </ValidationProvider>
          </div>

        </div>
      </div>

    </div>

    <div class="vx-row mb-3">
      <vs-alert :active="showWaringDate" color="warning" icon="icon-alert-triangle" icon-pack="feather">
        {{ $t('live-class-schedule.warning-date') }}
      </vs-alert>
    </div>

    <div class="vx-row mb-3">
      <div class="vx-col w-full">
        <label class="text-sm">{{$t('live-class-schedule.external-link')}}</label>
        <vs-input class="w-full" v-model="form.advisorOnlineScheduleInput.externalLink"/>
      </div>
    </div>

    <div class="vx-row mb-3">
      <div class="vx-col w-full">
        <label class="text-sm">{{$t('live-class-schedule.external-password')}}</label>
        <vs-input class="w-full" v-model="form.advisorOnlineScheduleInput.externalPassword"/>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full mb-2">
        <label class="text-sm">{{$t('live-class-schedule.remark')}}</label>
        <vs-textarea rows="3" v-model="form.advisorOnlineScheduleInput.remark"/>
      </div>
    </div>

  </vx-card>

</template>

<script>
  import {state} from '../data';
  import Datepicker from 'vuejs-datepicker';
  import vSelect from 'vue-select';
  import moment from 'moment';
  import {dateTimeFormat} from '@/utils/format'


  export default {
    components: {
      vSelect,
      Datepicker,
    },
    data() {
      return {
        store: state.store,
        local: state.local,
        dateTimeFormat: dateTimeFormat,

        classRoomEdit: state.local.classRoomEdit,
        advisorOnlineScheduleEdit: state.local.advisorOnlineScheduleEdit,
        form: state.local.advisorOnlineScheduleEdit.form,

      }
    },
    computed: {
      disabledStartDates() {
        if (this.classRoomEdit.selectedClassRoom && this.classRoomEdit.selectedClassRoom.startDate) {

          let startDate = moment.utc(this.classRoomEdit.selectedClassRoom.startDate);
          let endDate = moment.utc(this.classRoomEdit.selectedClassRoom.endDate);

          return {
            from: new Date(endDate.year(), endDate.month(), endDate.date()),
            to: new Date(startDate.year(), startDate.month(), startDate.date()),
          };
        } else {
          return {
            from: new Date(),
          };
        }
      },
      showWaringDate() {
        return this.advisorOnlineScheduleEdit.showWaringDate;
      }
    },
    watch: {
      advisorOnlineScheduleProcessing(data) {
        this.local.isProcessing = data;
      },
      classRoomProcessing(data) {
        this.local.isProcessing = data;
      },
      courseOutlineProcessing(data) {
        this.local.isProcessing = data;
      },
      classSectionProcessing(data) {
        this.local.isProcessing = data;
      },
    },
    methods: {
      //---------------------------------------- State Function ------------------------------------------------------//

      //---------------------------------------- Event Function ------------------------------------------------------//
      onDateFromChange() {
        this.form.advisorOnlineScheduleInput.dateTimeTo = this.form.advisorOnlineScheduleInput.dateTimeFrom;

        let selectedDate = moment(this.form.advisorOnlineScheduleInput.dateTimeTo);
        this.advisorOnlineScheduleEdit.selectedHourFrom = selectedDate.hour();
        this.advisorOnlineScheduleEdit.selectedMinuteFrom = selectedDate.minute();
        this.advisorOnlineScheduleEdit.selectedHourTo = selectedDate.hour();
        this.advisorOnlineScheduleEdit.selectedMinuteTo = selectedDate.minute();
      },
      onTimeChange() {
        this.checkTime();
      },
      //---------------------------------------- Local Function ------------------------------------------------------//
      checkTime() {
        let dateFrom = moment.utc(this.form.advisorOnlineScheduleInput.dateTimeFrom);
        let dateTo = moment.utc(this.form.advisorOnlineScheduleInput.dateTimeTo);

        dateFrom.set('hour', this.advisorOnlineScheduleEdit.selectedHourFrom);
        dateFrom.set('minute', this.advisorOnlineScheduleEdit.selectedMinuteFrom);
        dateTo.set('hour', this.advisorOnlineScheduleEdit.selectedHourTo);
        dateTo.set('minute', this.advisorOnlineScheduleEdit.selectedMinuteTo);

        this.advisorOnlineScheduleEdit.showWaringDate = dateTo.isSameOrBefore(dateFrom);
      },
      async initData() {
        //set initial date time
        this.onDateFromChange();
      },
    },
    async mounted() {
      await this.initData();
    }
  }

</script>

<style scoped>

</style>
